// extracted by mini-css-extract-plugin
export default {"profilesList":"profiles_list-modules___profilesList___fde339e0","profileItem":"profiles_list-modules___profileItem___fe3e3060"};